<script setup lang="ts">
import { computed, ref } from 'vue';
import { formatHelpers, AccordionContent } from '@hfc/ui-core';
import { SmallBusinessPlan } from '@/application/smallBusiness/domain/SmallBusinessPlan';
import { ContributionType } from '@/application/smallBusiness/domain/SmallBusinessContribution';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import PriceBreakdown from '@/planList/infrastructure/components/PriceBreakdown.vue';

const { formatPrice } = formatHelpers();

const props = defineProps<{
  plan: SmallBusinessPlan;
  applicationType: APPLICATION_TYPES;
  contributionType?: ContributionType;
  employeeContribution?: number;
  dependentContribution?: number;
}>();

const priceBreakdownVisible = ref<boolean>(true);

const totalCost = computed(() => {
  return props.plan.price_breakdown.reduce((acc, price) => acc + price.rate, 0);
});
</script>
<template>
  <AccordionContent v-model:open="priceBreakdownVisible" open-icon="chevron-up" closed-icon="chevron-down" open-icon-color="text-blue-600" open-class="bg-slate-200">
    <template #title>
      <div class="flex flex-col w-full">
        <div class="text-lg font-semibold text-blue-600">
          Pricing
        </div>
        <div v-if="!priceBreakdownVisible" class="flex text-sm sm:text-md sm:items-center justify-end space-x-4">
          <td class="font-medium text-right lg:whitespace-nowrap" colspan="3">Estimated Total Employer Contribution: <br class="sm:hidden" /><span class="ml-6 font-bold">{{ formatPrice(plan.totalEmployerContribution) }}</span></td>
          <td class="text-right font-medium" colspan="2">Estimated Total Cost: <br class="sm:hidden" /><span class="ml-6 font-bold">{{ formatPrice(totalCost) }}</span></td>
        </div>
      </div>
    </template>
    <template #content>
      <PriceBreakdown :plan="plan" :application-type="applicationType" :dependent-contribution="dependentContribution" :employee-contribution="employeeContribution" :contribution-type="contributionType" />
    </template>
  </AccordionContent>
</template>
